import React from "react";

import styles from "./matter-auto-complete-dropdown.css";

const { ["container"]: containerClassName } = styles as any;

export const MatterAutoCompleteDropdown: React.FC<{}> = ({ children }) => {
  return (
    <div className={containerClassName}>
      <div>{children}</div>
    </div>
  );
};
